export { ReactComponent as ExcelObject } from './svgs/excel-object.svg';
